export function makeUniqueOptions<T extends object, K extends keyof T>(
	array: T[] | undefined,
	field: K,
): { value: T[K]; label: T[K] }[] | undefined {
	return Array.from(new Set(array?.map((iter) => iter[field]))).map((value) => ({
		value,
		label: value,
	}));
}
